import React, { useEffect, useState } from 'react';
import { Alert, Form } from 'react-bootstrap';
import { authFetch } from '../utils/authFetch';

export default function HeaderCostCenter({ value, onChange, disabled = false }) {
  const [cfg, setCfg] = useState(null);
  const [error, setError] = useState('');
  useEffect(() => {
    let active = true;
    authFetch('/repartizari-centre/config').then(v => { if (active) setCfg(v); }).catch(e => { if (active) setError(e.message); });
    return () => { active = false; };
  }, []);
  if (error) return <Alert variant="danger">Centre de cost: {error}</Alert>;
  if (!cfg?.enabled) return null;
  return <Form.Group className="my-3">
    <Form.Label>Centru de cost pentru consum</Form.Label>
    <Form.Select aria-label="Centru de cost pentru consum" value={value || ''} disabled={disabled}
      onChange={e => onChange(e.target.value ? Number(e.target.value) : null)}>
      <option value="">Alege centrul de cost</option>
      {cfg.centers.map(c => <option key={c.id} value={c.id}>{c.code} — {c.name}</option>)}
    </Form.Select>
    <Form.Text>Bonul de consum generat preia acest centru și repartizează automat întreaga cheltuială.</Form.Text>
  </Form.Group>;
}
